<template>
  <div class="bg-gray-900 rounded-xl p-4 mt-4 text-sm text-white"
       @touchstart="toggleAnimation($event)" @touchend="toggleAnimation" @click="goToNote()">
    <div class="grid grid-cols-2">
        <span class="flex">
        <UserIcon class="w-5 h-5 text-yellow-300"/>
        <span class="mr-1">{{ note.Referred }}</span>
      </span>
       <span class="flex">
        <ClockIcon class="h-5 w-5 text-yellow-300"/>
        <span class="mr-1">{{ note.CeremonyDate }}</span>
      </span>
     

    </div>
    <div class="grid grid-cols-2 mt-3">
          <span class="flex items-center">
          <UserGroupIcon class="h-5 w-5 text-yellow-300"/>
        <span class="mr-1">{{ note.GuestCount }} نفر</span>
      </span>
      <span class="flex">
        <TableIcon class="h-5 w-5 text-yellow-300"/>
        <span class="mr-1">{{ note.CeremonyTypeTitle }}</span>
      </span>
    </div>
    <div class="grid grid-cols-2 mt-3">
        <span class="flex">
          <PhoneIcon class="h-5 w-5 text-yellow-300"/>
          <span class="mr-1">{{ note.Mobile }}</span>
      </span>
       <span class="flex">
        <ClipboardListIcon class="w-5 h-5 text-yellow-300"/>
        <span class="mr-1">{{ note.Title }}</span>
      </span>
    </div>
    <div class="grid grid-cols-2 mt-3">
      <span class="flex">
         <UserIcon class="h-5 w-5 text-yellow-300"/>
        <span class="mr-1 text-center">{{ note.FULLNAME }}</span>
      </span>
       <span class="flex">
         <CalendarIcon class="h-5 w-5 text-yellow-300"/>
        <span class="mr-1 text-center">{{ note.ReferredDate }}</span>
      </span>
    </div>

  </div>
</template>

<script>
import {ClockIcon, PhoneIcon, TableIcon, UserGroupIcon, UserIcon,CalendarIcon,ClipboardListIcon} from "@heroicons/vue/outline";

export default {
  name: "NoteCard",
  components: {
    UserIcon,
    ClockIcon,
    TableIcon,
    UserGroupIcon,
    CalendarIcon,
    ClipboardListIcon,
    PhoneIcon,
  },
  props: ['note'],
  methods: {
    toggleAnimation(event) {
      event.currentTarget.classList.toggle('border-yellow-500')
      event.currentTarget.classList.toggle('border')
    },
    goToNote() {
      this.$router.push('/note-list/' + this.note.Id)
    }
  }
}
</script>

<style scoped>

</style>